import { render, staticRenderFns } from "./TranslationPreviewModal.vue?vue&type=template&id=2b29886d&scoped=true&"
import script from "./TranslationPreviewModal.vue?vue&type=script&lang=js&"
export * from "./TranslationPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./TranslationPreviewModal.vue?vue&type=style&index=0&id=2b29886d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b29886d",
  null
  
)

export default component.exports